import React, { useState } from 'react';
import { EventPlanModal } from '../../components/EventPlan/EventPlanModal';

import {
  EventPlanForm,
  EventPlanFormEventPlan,
} from '../../components/EventPlan/EventPlanForm';

export const defaultEventPlanInput: EventPlanFormEventPlan = {
  name: '',
  startOffset: 16 * 60,
  endOffset: 20 * 60,
  groupSize: 20,
  location: '',
};
export const CreateEventPlanModal = ({
  isOpen,
  onClose,
  onCreate,
}: {
  isOpen: boolean;
  onClose: () => void;
  onCreate: ({
    name,
    startDate,
    startOffset,
    endOffset,
    groupSize,
    location,
  }: EventPlanFormEventPlan) => void;
}) => {
  const [eventPlan, setEventPlan] = useState<EventPlanFormEventPlan>(
    defaultEventPlanInput,
  );

  const handleChange = (eventPlan: EventPlanFormEventPlan) => {
    setEventPlan(eventPlan);
  };

  const handleCreate = () => {
    if (!eventPlan) return;
    onCreate(eventPlan);
    onClose();
  };

  return (
    <EventPlanModal
      title="Create Event"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleCreate}
    >
      <EventPlanForm eventPlan={eventPlan} onChange={handleChange} />
    </EventPlanModal>
  );
};
